import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-external-data-source/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-external-data-source/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/wagon-tippler-external-data-source/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-external-data-source/selectPage',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/wagon-tippler-external-data-source/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

